import './LiveDot.css';

export default function LiveDot({ color = 'positive', size = 6, pulse = true }) {
  return (
    <span
      className={`live-dot live-dot--${color}${pulse ? '' : ' live-dot--static'}`}
      style={{ width: size, height: size }}
    />
  );
}
